'use client';

import { Field, Textarea, TextareaProps } from '@headlessui/react';
import { ChangeEvent, Ref, useEffect, useState } from 'react';
import TextareaAutosize from 'react-textarea-autosize';

import { styles } from './UiKitTextareaBase.styles';

type BaseTextareaProps = Omit<TextareaProps, 'invalid' | 'onChange'>;

export interface UiKitTextareaBaseProps extends BaseTextareaProps {
  label?: string;
  helperText?: string;
  error?: boolean;
  required?: boolean;
  showCount?: boolean;
  maxLength?: number;
  onChange?: (value: string) => void;
  ref?: Ref<HTMLTextAreaElement>;
  className?: string;
}

export function UiKitTextareaBase({
  label,
  helperText,
  error,
  required,
  onChange,
  placeholder = '',
  rows = 1,
  showCount = false,
  maxLength = 6000,
  ref,
  value: initialValue = '',
  className,
  ...props
}: UiKitTextareaBaseProps) {
  const slots = styles({ error });

  const [value, setValue] = useState(initialValue);

  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  const handleChange = (event: ChangeEvent<HTMLTextAreaElement>) => {
    setValue(event.target.value);
    onChange?.(event.target.value);
  };

  return (
    <Field className={slots.base({ className })}>
      <div className={slots.wrapper()}>
        <Textarea
          as={TextareaAutosize}
          placeholder={placeholder}
          className={slots.textarea()}
          maxLength={maxLength}
          onChange={handleChange}
          ref={ref}
          rows={rows}
          value={value}
          {...props}
        />
        {label && (
          <label className={slots.label()}>
            {label}
            {required && <span className={slots.required()}>*</span>}
          </label>
        )}
      </div>
      {!!helperText && <div className={slots.helperText()}>{helperText}</div>}
      {showCount && value && (
        <div className={slots.count()}>
          {value.toString().length}/{maxLength}
        </div>
      )}
    </Field>
  );
}
